import { useMutation, useQuery } from "react-query";
import { queryClient } from "../query";
import { Logout, publicAxios, secureAxios } from "../../constant/auth";
import {
  linkedPharmacyAtom,
  userDataAtom,
} from "../../../components/user/User-Detail/user-details-tab/UserDetailsAtom";
import { useAtom } from "jotai";
import { useNavigate } from "react-router-dom";
import { doctor_personal_details } from "../../../components/user/User-Detail/user-details-tab/UserDetailsAtom";
export const useLoginUser = (collection) => {
  let query = `/${collection}`;

  return useMutation(
    (createItem) => {
      return publicAxios.post(`${query}`, createItem).then((res) => res);
    },
    {
      onSuccess: (data, variables, context) => {
        //("data", data);
        queryClient.invalidateQueries(["items", collection]);
        queryClient.invalidateQueries(["user_data"]);
      },
    }
  );
};

export const useAuth = () => {
  const [, setUserDataAtom] = useAtom(userDataAtom);
  const [, setDoctorPersonalDetails] = useAtom(doctor_personal_details);
  const [, setLinkedPharmacy] = useAtom(linkedPharmacyAtom);

  const navigate = useNavigate();

  return useQuery(
    ["auth", localStorage.getItem("access_token")],
    () =>
      secureAxios
        .get(`users/?action=getUserMe&frontend=True`)
        .then((res) => {
          setUserDataAtom(res?.data?.family_member);
          setDoctorPersonalDetails(res?.data?.user?.doctor_personal_details);
          setLinkedPharmacy(res?.data?.linked_pharmacy);
          return res;
        })
        .catch((err) => {
          // if (err?.response?.data?.code === "token_not_valid") {
          Logout();
          navigate("/login");
          // }
        }),
    {
      enabled: Boolean(localStorage.getItem("access_token")),
    }
  );
};
